export default __webpack_public_path__ + "static/media/banner2.d0b18cbc.jpg";